import { render, staticRenderFns } from "./digitalHumanAppearance.vue?vue&type=template&id=09cb41ad&scoped=true"
import script from "./digitalHumanAppearance.vue?vue&type=script&lang=js"
export * from "./digitalHumanAppearance.vue?vue&type=script&lang=js"
import style0 from "./digitalHumanAppearance.vue?vue&type=style&index=0&id=09cb41ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cb41ad",
  null
  
)

export default component.exports